module.exports = __webpack_public_path__ + "img/agency-badge-dark.35818683.svg";